import { PayloadAction } from '@reduxjs/toolkit';
import { SyfoAppState } from '../state';
import { PetNode } from '@syfo/types/vault.types';
import { updateById } from './reducer-utils';

export const addPet = (state: SyfoAppState, action: PayloadAction<PetNode>) => {
  if (state.currentVault) {
    state.currentVault.data.pets.push(action.payload);
  }
};

export const updatePet = (state: SyfoAppState, action: PayloadAction<{ id: string; pet: Partial<PetNode> }>) => {
  if (state.currentVault) {
    updateById(state.currentVault.data.pets, action.payload.id, action.payload.pet);
  }
};

export const removePet = (state: SyfoAppState, action: PayloadAction<string>) => {
  if (state.currentVault) {
    state.currentVault.data.pets = state.currentVault.data.pets.filter(p => p.id !== action.payload);
  }
};
